export default {
	'THEME': 'madamesumuk',
	"BRAND": "madamesumuk",
	"DEFAULT_CHANNEL": "uk",
	"DEFAULT_ENTRYPOINT": "madamesumuk",
	"DEFAULT_TAXON_HIGHLIGHT_PRODUCTS": "alluk",
	"CHECKOUT_MERCHANT_ID": "1100004624",
	"LANGUAGE": "en-GB",
	"LOCALE": "en_GB",
	"COUNTRY": "GB",

	// FEATURES
	"FEATURE_ADDRESS_AUTOCOMPLETE": false,

	// THEME VALUES
	"THEME_CURRENCY": "GBP",
	"THEME_CURRENCY_PREFIX": "£",
	"THEME_COUNTRY": "GB",
	"THEME_COUNTRY_LIST": [
		'GB'
	],
	"THEME_ZIP_ATTRIBUTES": {
		minlength: 5,
		maxlength: 8,
		inputmode: 'text',
	},
	"THEME_ZIP_ALLOWED_CHARS": '0-9 A-Z',
	"THEME_ZIP_REGEX": '^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$',
	"THEME_REVERSE_STREET_NUMBER": true,
}
